import { UploadStatus } from "./upload.types";
import Progress from "./progress";
import { Icon } from "@mindlercare/ui-web";
import { styled } from "styled-components";

type Props = {
  file: File;
  uploadStatus: UploadStatus;
};

const ProgressWrapper = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  min-height: 20px;
  position: absolute;
  top: 0;
`;

const CheckIcon = styled(Icon.Done)<{ visible: boolean }>`
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  margin-left: 8px;
  color: ${({ theme }) => theme.COLORS.SUCCESS};
`;

export const ProgressBar = ({ file, uploadStatus }: Props) => {
  const isActive = uploadStatus.uploading || uploadStatus.successfulUploaded;
  if (!isActive) return null;

  const uploadProgress = uploadStatus.uploadProgress?.[file.name];

  return (
    <ProgressWrapper>
      <Progress progress={uploadProgress ? uploadProgress.percentage : 0} />
      <CheckIcon
        visible={!!uploadProgress && uploadProgress.state === "done"}
        data-testid="progressbar-check-icon"
      />
    </ProgressWrapper>
  );
};
